export { default } from './assignInWith.js'



//////////////////
// WEBPACK FOOTER
// /Users/abonnal/Dev/jean-louis-david.lan/web/app/themes/jld/node_modules/lodash-es/extendWith.js
// module id = 235
// module chunks = 0